import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

// Pages
import { HomePage } from './pages';
import { TenantEntryPage } from './pages/TenantEntryPage';

// Components
import { ProtectedRoute } from './components/ProtectedRoute';

// Theme
import { ThemeProvider } from './theme';

// Contexts
import { SpeechVoiceProvider } from './contexts/SpeechVoiceContext';

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <SpeechVoiceProvider>
          <Routes>
            {/* Public - Landing page with auth panel */}
            <Route path="/" element={<TenantEntryPage />} />

            {/* Protected - Main app */}
            <Route
              path="/home"
              element={
                <ProtectedRoute>
                  <HomePage />
                </ProtectedRoute>
              }
            />
          </Routes>

          {/* Toast Notifications (global) */}
          <ToastContainer
            position="top-right"
            autoClose={4000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </SpeechVoiceProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;
